import { CommonModule } from '@angular/common';
import { Component, computed, input, output, TemplateRef, viewChild } from '@angular/core';

import { IPaginationResponseResolver, IPaginationParameters } from '../../../data-access';
import { IActionConfig, IActionExecutedEvent, ITableConfig, PaginatedTableComponent } from '../../../ui';
import { ILookup } from '../../../primitives';

@Component({
  selector: 'app-lookups',
  standalone: true,
  providers: [],
  imports: [PaginatedTableComponent, CommonModule],
  templateUrl: './lookups.component.html',
  styleUrls: ['./lookups.component.scss']
})
export class LookupsComponent<TEntity extends ILookup<string>, TPaginationParameters extends IPaginationParameters> {
  tableRowTemplate = viewChild.required<TemplateRef<{ $implicit: TEntity }>>('tableRowTemplate');
  paginationResponseResolver = input.required<IPaginationResponseResolver<TEntity, TPaginationParameters>>();
  defaultPaginationParameters = input.required<TPaginationParameters>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  tableConfig = input<ITableConfig>();

  actionExecuted = output<IActionExecutedEvent<TEntity>>();

  finalTableConfig = computed(() => ({
    fields: [
      { name: 'autoIncrementalId', displayName: 'Id' },
      { name: 'englishName', displayName: 'GENERAL.ENGLISH_NAME' },
      ...(this.tableConfig()?.fields ?? [])
    ],
    template: this.tableRowTemplate()
  }));

  onActionExecuted(event: unknown) {
    this.actionExecuted.emit(event as IActionExecutedEvent<TEntity>);
  }
}
